import { render, staticRenderFns } from "./DialogFinishConversations.vue?vue&type=template&id=1a51fb06"
import script from "./DialogFinishConversations.vue?vue&type=script&lang=js"
export * from "./DialogFinishConversations.vue?vue&type=script&lang=js"
import style0 from "./DialogFinishConversations.vue?vue&type=style&index=0&id=1a51fb06&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports